import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IApprovalRequestCategory } from '@appshared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApprovalRequestMainSidebarService {
  protected resourceUrl = '/hrm-portal-api/api/categories/';

  constructor(public http: HttpClient) {}

  getCategories(): Observable<IApprovalRequestCategory[]> {
    return this.http.get<IApprovalRequestCategory[]>(this.resourceUrl);
  }
}
